module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/49shyc/cover.jpeg?1684514558397",
      "alt": "This image is the cover for the book Unparalleled Talisman God, Volume 5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unparalleled Talisman God, Volume 5\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('strong', [_vm._v("\"You can refine medicine, but you can quickly break through?\" \"One of my Spirit Convergence Talismans can increase my cultivation speed by ten or even a hundred times!\"")])]), _c('p'), _c('p', [_vm._v("\"You know how to forge weapons, and forging a divine weapon that can slay stars? I have the Nine Heavens Thunder Rune. I can summon the thunder from the Nine Heavens Divine Thunder, turning thousands of kilometers into ashes with a single attack! \" \"Are you skilled in formations? Can you attack or defend?\" I have tens of thousands of inscriptions, and the lives of others depend on me! \"  Ten thousand years ago, the Nine Heavens Supreme Elder perished … ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dong FangXingYun, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0